export const getWeatherDetails = (code) => {
  // WMO Weather interpretation codes (https://open-meteo.com/en/docs)
  if (code === 0) return { label: 'Clear sky', icon: 'Sun', color: 'text-yellow-500' };
  if (code === 1 || code === 2 || code === 3) return { label: 'Partly cloudy', icon: 'Cloud', color: 'text-gray-400' };
  if (code === 45 || code === 48) return { label: 'Fog', icon: 'AlignJustify', color: 'text-gray-500' };
  if (code >= 51 && code <= 55) return { label: 'Drizzle', icon: 'CloudDrizzle', color: 'text-blue-400' };
  if (code >= 61 && code <= 67) return { label: 'Rain', icon: 'CloudRain', color: 'text-blue-500' };
  if (code >= 71 && code <= 77) return { label: 'Snow', icon: 'CloudSnow', color: 'text-blue-200' };
  if (code >= 80 && code <= 82) return { label: 'Rain showers', icon: 'CloudRain', color: 'text-blue-500' };
  if (code >= 85 && code <= 86) return { label: 'Snow showers', icon: 'CloudSnow', color: 'text-blue-200' };
  if (code >= 95 && code <= 99) return { label: 'Thunderstorm', icon: 'CloudLightning', color: 'text-purple-500' };
  return { label: 'Unknown', icon: 'HelpCircle', color: 'text-gray-400' };
};

export const getExpectedDrivingConditions = (weatherCode, minTemp) => {
  // Logic updated to align with PEI 511 terminology
  
  // Snow codes (71-86)
  if (weatherCode >= 71 && weatherCode <= 86) {
    if (minTemp > 1) return { 
      status: 'Bare with Slushy Patches', 
      description: 'Snow is falling but temperatures are above freezing. Roads may be slushy.', 
      alertLevel: 'medium', 
      icon: 'Droplets' 
    };
    return { 
      status: 'Snow Covered / Slippery', 
      description: 'Winter driving conditions. Roads may be snow-covered. Plows may be active.', 
      alertLevel: 'high', 
      icon: 'AlertTriangle' 
    };
  }

  // Rain/Drizzle codes (51-67, 80-82)
  if ((weatherCode >= 51 && weatherCode <= 67) || (weatherCode >= 80 && weatherCode <= 82)) {
    if (minTemp <= 0) {
      return { 
        status: 'Icy / Black Ice Risk', 
        description: 'Freezing rain or moisture on cold pavement. High risk of slippery sections.', 
        alertLevel: 'critical', 
        icon: 'AlertOctagon' 
      };
    }
    return { 
      status: 'Bare with Moisture Present', 
      description: 'Roads are wet. Good visibility but watch for hydroplaning in heavy rain.', 
      alertLevel: 'medium', 
      icon: 'Droplet' 
    };
  }

  // Cold but clear
  if (minTemp < 0) {
    return { 
      status: 'Bare and Dry / Frost', 
      description: 'Roads are generally clear. Watch for localized frost or icy patches on bridges.', 
      alertLevel: 'low', 
      icon: 'Thermometer' 
    };
  }

  // Ideal conditions
  return { 
    status: 'Bare and Dry', 
    description: 'Good driving conditions. No weather-related delays anticipated.', 
    alertLevel: 'low', 
    icon: 'CheckCircle' 
  };
};